const initialState = {
  chat: [],
  announcements: [],
  academy: [],
  trafficReports: [],
  foodSpots: [],
  lostFound: [],
  emergencyAlerts: [],
  polls: [],
  achievements: [],
  marketplace: [],
  events: [],
  marketplaceMessages: {},
  marketplaceConversations: [],
  myReputation: {},
  allDriverReputations: [],
};

export default function communityReducer(state = initialState, action) {
  switch (action.type) {
    case 'COMMUNITY_CHAT_LOADED':
      return { ...state, chat: action.payload };
    case 'ANNOUNCEMENTS_LOADED':
      return { ...state, announcements: action.payload };
    case 'ACADEMY_LOADED':
      return { ...state, academy: action.payload };
    case 'TRAFFIC_REPORTS_LOADED':
      return { ...state, trafficReports: action.payload };
    case 'FOOD_SPOTS_LOADED':
      return { ...state, foodSpots: action.payload };
    case 'LOST_FOUND_LOADED':
      return { ...state, lostFound: action.payload };
    case 'EMERGENCY_ALERTS_LOADED':
      return { ...state, emergencyAlerts: action.payload };
    case 'POLLS_LOADED':
      return { ...state, polls: action.payload };
    case 'ACHIEVEMENTS_LOADED':
      return { ...state, achievements: action.payload };
    case 'MARKETPLACE_LOADED':
      return { ...state, marketplace: action.payload };
    case 'MARKETPLACE_MESSAGES_LOADED':
      return { ...state, marketplaceMessages: { ...state.marketplaceMessages, [action.payload.conversationId]: action.payload.messages } };
    case 'MARKETPLACE_CONVERSATIONS_LOADED':
      return { ...state, marketplaceConversations: action.payload };
    case 'EVENTS_LOADED':
      return { ...state, events: action.payload };
    case 'DRIVER_REPUTATION_LOADED':
      return { ...state, myReputation: action.payload };
    case 'ALL_DRIVER_REPUTATIONS_LOADED':
      return { ...state, allDriverReputations: action.payload };
    default:
      return state;
  }
}
